/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const NoDriverShowIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      className="w-6 h-6"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        d="M16,0C7.178,0,0,7.178,0,16s7.178,16,16,16,16-7.178,16-16S24.822,0,16,0Zm-1.492,6.5c0-.276,.224-.5,.5-.5h1.984c.276,0,.5,.224,.5,.5v12c0,.276-.224,.5-.5,.5h-1.984c-.276,0-.5-.224-.5-.5V6.5Zm1.492,19.5c-1.105,0-2-.895-2-2s.895-2,2-2,2,.895,2,2-.895,2-2,2Z"
        fill={color}
      />
    </svg>
  );
};
